export default __webpack_public_path__ + "static/media/leavesBorder2.4723e14f.svg";